export default {"src":"/_next/static/media/calendar-left-arrow.3ee87f0c.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};